import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  buttonStyle: {
    marginTop: 20,
    marginHorizontal: 8,
  },
  buttonTextStyle: {
    fontSize: 18.7,
    letterSpacing: 0,
    lineHeight: 24,
  },

  containerStyle: {
    paddingBottom: 35,
    paddingHorizontal: 10,
    paddingTop: 5,
  },
  labelTextStyle: {
    fontFamily: Fonts.type.VFFont,
  },

  passwordInputStyle: {
    marginTop: 15,
  },

  textStyle: theme => ({
    color: theme.colors.hyperlinkThree,
    fontSize: 14.6,
    lineHeight: 18.7,
    fontFamily: Fonts.type.VFFont,
    textDecorationLine: 'underline',
  }),

  disabledBUttonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  disabledTextStyle: theme => ({
    color: theme.colors.textButtons.disabled,
  }),
});
